module.exports = __webpack_public_path__ + "static/media/overpass-mono-regular.88c46de6.ttf";